<app-gmao-spinner *ngIf="!pannes"></app-gmao-spinner>
<ng-container *ngIf="pannes && pannes.installation_rg_pannes_headers">
    <div class="w-100 text-center">
        <pagination-controls id="page-pannes" style="text-align: center;" (pageChange)="pageChange($event)"
            previousLabel="Précédent" nextLabel="Suivant"></pagination-controls>
        <p>{{installation.machine.emails_count}} messages de pannes</p>
    </div>
    <table class="table table-sm">
        <ng-container
            *ngFor="let panne of pannes.installation_rg_pannes_headers | paginate : {itemsPerPage: 30, currentPage: p+1, totalItems: installation.machine.emails_count, id: 'page-pannes'}">
            <tr [className]="panne.traite ? 'processed' : 'to_process' ">
                <td> {{convertDate(panne.date_panne)}}</td>
                <td>{{panne.sujet}}</td>
                <ng-container *ngIf="panne.traite">
                    <td class="text-right">Traité</td>
                    <td>
                        <ng-container *ngIf="panne.solver">par {{panne.solver.user_login}} le {{convertDate(panne.solver.state_time)}}</ng-container>
                    </td>
                </ng-container>
                <ng-container *ngIf="!panne.traite">
                    <td class="text-right pointer" (click)="markAsDeal(panne.id_rg_panne, panne.traite)">
                        Marquer comme traité
                    </td>
                    <td></td>
                </ng-container>

            </tr>
        </ng-container>
    </table>
</ng-container>